function removeDefaultTitle() {
    document.querySelectorAll('.cart-line-item__variant-title').forEach(function(el) {
        if (!el.textContent.includes(' — ') || el.textContent.includes('Default Title')) {
            el.remove();
        }
    });
}

Amethyst.EventBus.listen("AjaxCart:updated", function() {
    setTimeout(removeDefaultTitle, 100);
});

Amethyst.EventBus.listen("AjaxCart:itemAdded", function() {
    setTimeout(removeDefaultTitle, 100);
});

Amethyst.EventBus.listen("AjaxCart:itemRemoved", function() {
    setTimeout(removeDefaultTitle, 100);
});